const DEFAULT_HOME_PATH = '/projects';
const SPECIAL_TENANT_HOME_PATH = '/supervisory/insights';

const stripPort = (host: string): string => host.replace(/:\d+$/, '');

const normalizeHost = (host: string): string =>
  stripPort(host.trim().toLowerCase());

export function getHomePathFromHost(host: string): string {
  const normalizedHost = normalizeHost(host);

  const overrideHost =
    process.env.NEXT_PUBLIC_HOME_ROUTE_OVERRIDE_HOSTNAME?.trim();
  if (overrideHost && normalizeHost(overrideHost) === normalizedHost) {
    return SPECIAL_TENANT_HOME_PATH;
  }

  return DEFAULT_HOME_PATH;
}
